import { deploymentOnline } from '../../utils/deployments';

export const ONLINE = 'ONLINE';
export const OFFLINE = 'OFFLINE';
export const ALERT = 'ALERT';

export function statusColor(status) {
  if (status === ONLINE) {
    return 'success'; // Green color for copacetic
  }
  if (status === ALERT) {
    return 'warning'; // Yellow color for data alert
  }
  return 'error'; // Red color for offline
}

export function statusLink(status, row) {
  if (status === ALERT) {
    return '/data-alerts';
  }
  return `/dashboard?bid=${row.original.id}`;
}

export function determineStatus(now, latestHeartbeat, alerts, bid, eid) {
  const matcher = eid
    ? (a) => (a?.equipment ?? []).includes(eid)
    : (a) => (a?.buildings ?? []).includes(bid);
  if (alerts.filter((a) => matcher(a) && a.fire_state === 'ALERT').length > 0) return ALERT;
  if (!deploymentOnline(now, latestHeartbeat)) return OFFLINE;
  return ONLINE;
}
